(() => {
  'use strict';

  const DATA_SELECTOR = 'script[data-ht-atc-pricing]';
  const LABEL_SELECTOR = '[data-ht-atc-label]';
  const VARIANT_SELECTOR = 'input[name="id"]';
  const SELLING_PLAN_SELECTOR = 'input[name="selling_plan"]';
  let updateFrame = 0;

  function parseData(node) {
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('Unable to parse Add to Cart pricing data.', error);
      return null;
    }
  }

  function formatMoney(cents, data) {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: data.currencyCode || 'USD',
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (error) {
      return `$${value.toFixed(2)}`;
    }
  }

  function getInputValue(section, selector) {
    const inputs = section.querySelectorAll(selector);
    for (const input of inputs) {
      if (input.value) return String(input.value);
    }
    return '';
  }

  function getActivePricing(section, variant) {
    const sellingPlanId = getInputValue(section, SELLING_PLAN_SELECTOR);
    const plans = Array.isArray(variant.sellingPlans) ? variant.sellingPlans : [];
    const sellingPlan = plans.find(item => String(item.id) === sellingPlanId);
    return {
      price: Number(sellingPlan?.price || variant.price || 0),
      compareAt: Number(variant.compareAtPrice || sellingPlan?.compareAtPrice || 0),
    };
  }

  function buildLabel(pricing, data) {
    const price = Number(pricing.price || 0);
    const compareAt = Number(pricing.compareAt || 0);
    if (compareAt > price && compareAt > 0) {
      let percent = Math.round(((compareAt - price) * 100) / compareAt);
      if ((data.productHandle === 'starter' || data.productHandle === 'sleep-starter-kit') && percent === 50) percent = 51;
      if (percent > 0) return `ADD TO CART - SAVE ${percent}%`;
    }
    return `ADD TO CART - ${formatMoney(price, data)}`;
  }

  function updateDataNode(dataNode) {
    const data = parseData(dataNode);
    if (!data || !Array.isArray(data.variants)) return;
    const section = dataNode.closest('.shopify-section') || document.getElementById(`shopify-section-${data.sectionId}`);
    if (!section) return;
    const variantId = getInputValue(section, VARIANT_SELECTOR);
    const variant = data.variants.find(item => String(item.id) === variantId) || data.variants[0];
    if (!variant) return;
    const label = buildLabel(getActivePricing(section, variant), data);
    section.querySelectorAll(LABEL_SELECTOR).forEach(node => {
      const button = node.closest('button');
      if (button && (button.disabled || button.hasAttribute('data-pre-order'))) return;
      if (node.textContent.trim() !== label) node.textContent = label;
      node.dataset.htAtcDefaultLabel = label;
    });
  }

  function updateAll() {
    document.querySelectorAll(DATA_SELECTOR).forEach(updateDataNode);
  }

  function scheduleUpdate() {
    if (updateFrame) return;
    updateFrame = requestAnimationFrame(() => {
      updateFrame = 0;
      updateAll();
    });
  }

  function isRelevantClick(target) {
    return Boolean(target?.closest?.('.quantity-option, .style-button, .ht-sub-option, .sub-card, [data-ht-atc-label]'));
  }

  function isRelevantChange(target) {
    return Boolean(target?.matches?.(`${VARIANT_SELECTOR}, ${SELLING_PLAN_SELECTOR}, .subscription-options input`));
  }

  if (!window.__htAtcSavingsInitialized) {
    window.__htAtcSavingsInitialized = true;
    document.addEventListener('ht:pdp-change', scheduleUpdate);
    document.addEventListener('change', event => {
      if (isRelevantChange(event.target)) scheduleUpdate();
    }, true);
    document.addEventListener('click', event => {
      if (isRelevantClick(event.target)) scheduleUpdate();
    }, true);
    document.addEventListener('variant:change', scheduleUpdate);
    document.addEventListener('product:variant-change', scheduleUpdate);
    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
    window.addEventListener('pageshow', scheduleUpdate);
  }

  scheduleUpdate();
})();
